import { Component, OnInit } from '@angular/core';

const DISMISS_KEY = 'mir.gestimmoBannerDismissed';

@Component({
  selector: 'mir-gestimmo-banner',
  templateUrl: './gestimmo-banner.component.html',
  styleUrls: ['./gestimmo-banner.component.css'],
  standalone: false,
})
export class GestimmoBannerComponent implements OnInit {
  visible = false;
  confirming = false;
  showingInfo = false;

  ngOnInit(): void {
    this.visible = localStorage.getItem(DISMISS_KEY) !== 'true';
  }

  // Premier clic sur le bouton : on informe avant de quitter Mir, on ne
  // navigue pas directement.
  openInfo(event: Event): void {
    event.preventDefault();
    this.showingInfo = true;
  }

  closeInfo(): void {
    this.showingInfo = false;
  }

  requestDismiss(): void {
    this.confirming = true;
  }

  cancelDismiss(): void {
    this.confirming = false;
  }

  confirmDismiss(): void {
    localStorage.setItem(DISMISS_KEY, 'true');
    this.visible = false;
    this.confirming = false;
  }
}
